import { useAccount, useConfig } from "wagmi";
import {  useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";

import  CommissionManagerAbi from "../assets/abis/CommissionManagerAbi.json";
import { CommissionManager} from "../constants";
import { formatUnits } from "viem";


function  useW3Swap() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      
      const USDTCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0x55d398326f99059fF775485246999027B3197955"]
          }
        ]
      })
      const BNBCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"]
          }
        ]
      })
      const USD1Commission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d"]
          }
        ]
      })
      const FISTCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0xC9882dEF23bc42D53895b8361D0b1EDC7570Bc6A"]
          }
        ]
      })
      const USDCCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"]
          }
        ]
      })
            const BUSDCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"]
          }
        ]
      })
            const ETHCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0x2170Ed0880ac9A755fd29B2688956BD959F933F8"]
          }
        ]
      })
            const BTCCommission= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: CommissionManagerAbi,
            address: CommissionManager,
            functionName: 'pendingCommissions',
            args: [address,"0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c"]
          }
        ]
      })

      setValue({
        USDTCommission:parseFloat(formatUnits(USDTCommission[0], 18)).toFixed(4),
        BNBCommission:parseFloat(formatUnits(BNBCommission[0], 18)).toFixed(4),
        USD1Commission:parseFloat(formatUnits(USD1Commission[0], 18)).toFixed(4),
        FISTCommission:parseFloat(formatUnits(FISTCommission[0], 18)).toFixed(4),
        USDCCommission:parseFloat(formatUnits(USDCCommission[0], 18)).toFixed(4),
        BUSDCommission:parseFloat(formatUnits(BUSDCommission[0], 18)).toFixed(4),
        ETHCommission:parseFloat(formatUnits(ETHCommission[0], 18)).toFixed(4),
        BTCCommission:parseFloat(formatUnits(BTCCommission[0], 18)).toFixed(4),
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config])

  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime]);

  return value
}

export default useW3Swap